import { render, staticRenderFns } from "./SignFileWrap.vue?vue&type=template&id=5293c825&scoped=true"
import script from "./SignFileWrap.vue?vue&type=script&lang=js"
export * from "./SignFileWrap.vue?vue&type=script&lang=js"
import style0 from "./SignFileWrap.vue?vue&type=style&index=0&id=5293c825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5293c825",
  null
  
)

export default component.exports